export const SET_ORDER_INFO = 'SET_ORDER_INFO';
